// extracted by mini-css-extract-plugin
export var label = "_ig-2";
export var slideContainer = "_ig-0";
export var slider = "_ig-1";